export default "__VITE_ASSET__DYgFOIlU__"